import { AxiosResponse } from 'axios';
import apiClient from '../axios';
import { IGetSectorListResponse, Sector } from './interfaces';

export const getSectorList = async (): Promise<Sector[]> => {
  const response: AxiosResponse<IGetSectorListResponse> = await apiClient.get(
    '/sectors/list'
  );

  return response.data.data;
};

export const getLeafSectorList = async (): Promise<Sector[]> => {
  const response: AxiosResponse<IGetSectorListResponse> = await apiClient.get(
    '/sectors/leaf/list'
  );

  return response.data.data;
};

export const getSubSectorList = async (parentId: number): Promise<Sector[]> => {
  const response: AxiosResponse<IGetSectorListResponse> = await apiClient.get(
    `/sectors/${parentId}/list`
  );

  return response.data.data;
};
